import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container d-flex align-center ga-1 ga-lg-2" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "d-flex align-center ga-0 ga-md-1 ga-lg-2" }

import { useDisplay } from "vuetify";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

import {
  ROUTE_ABOUT,
  ROUTE_SELECT_COLLECTION,
  ROUTE_HOME,
  ROUTE_INVITE,
} from "@/utils/constants";

import ActiveAccountBtn from "@/components/Account/ActiveAccountBtn.vue";
import WalletConnectBtn from "@/components/WalletConnect/WalletConnectBtn.vue";
import ToggleDarkMode from "@/components/Header/ToggleDarkMode.vue";
import NetworkSelector from "@/components/Header/NetworkSelector.vue";
import CurrencySelector from "@/components/Header/CurrencySelector.vue";
import LanguageSelector from "@/components/Header/LanguageSelector.vue";
import AppLogo from "@/components/Common/AppLogo.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const route = useRoute();
const { smAndDown } = useDisplay();
const { t } = useI18n();

const menuItems = [
  {
    routeName: ROUTE_HOME,
    text: t("common.tokenList"),
  },
  {
    routeName: ROUTE_SELECT_COLLECTION,
    text: t("blocks.appHeader.createToken"),
  },
  {
    routeName: ROUTE_INVITE,
    text: t("blocks.appHeader.invite"),
  },
  {
    routeName: ROUTE_ABOUT,
    text: t("blocks.appHeader.about"),
  },
];

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    app: "",
    fixed: "",
    location: "top",
    class: "bcl-app-header px-3 px-sm-4"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(AppLogo, {
            class: "logo-btn mr-md-3 mr-lg-6",
            linked: ""
          }),
          (!_unref(smAndDown))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(menuItems, ({ routeName, text }, index) => {
                return _createVNode(_component_v_btn, {
                  key: index,
                  class: "menu-link",
                  color: _unref(route).name === routeName ? 'secondary' : 'primary',
                  to: { name: routeName },
                  exact: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(text), 1)
                  ]),
                  _: 2
                }, 1032, ["color", "to"])
              }), 64))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_v_spacer),
        _createElementVNode("div", _hoisted_3, [
          (!_unref(smAndDown))
            ? (_openBlock(), _createBlock(NetworkSelector, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(ToggleDarkMode),
          (!_unref(smAndDown))
            ? (_openBlock(), _createBlock(CurrencySelector, { key: 1 }))
            : _createCommentVNode("", true),
          _createVNode(LanguageSelector),
          _createVNode(WalletConnectBtn, {
            size: "large",
            outlined: ""
          }),
          _createVNode(ActiveAccountBtn)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})